import { useEffect } from '@integrations/react'
import { useCreateExpenseRequestMutation } from 'mmfintech-backend-api'
import type { ExpenseIn } from 'mmfintech-backend-api/types'
import type { UseFormValuesOutput } from 'mmfintech-commons/types'

export function useCreateExpenseRequest(formValues: UseFormValuesOutput) {
  const [createExpenseRequest, { error: expenseRequestsError, isLoading: expenseRequestsFetching }] =
    useCreateExpenseRequestMutation()

  function handleSubmit(description: string, onSuccess?: () => void) {
    createExpenseRequest({
      description,
      ...formValues.prepare()
    } as ExpenseIn)
      .unwrap()
      .then(onSuccess)
      .catch(() => {
        return
      })
  }
  useEffect(() => {
    if (expenseRequestsError) {
      formValues.handleErrors(expenseRequestsError)
    }
  }, [expenseRequestsError, formValues.handleErrors])

  return {
    isLoading: expenseRequestsFetching,
    expenseRequestsError,
    handleSubmit
  }
}
